@import '../../../node_modules/@wdpr/shared-device/device';
@import '../../../node_modules/@wdpr/shared-device/ie';
@import '../../../node_modules/@wdpr/typography/wdpr-typography-utilities';
@import '../../../node_modules/@wdpr/mdx-icons/wdpr-mdx-icons-utilities';
@import '../../../node_modules/@wdpr/color/wdpr-color-utilities';

:host {
  position: relative;
  display: inline-block;
  margin: var(--datepicker-margin);
  --input-width: var(--datepicker-input-width);
  --input-min-width: var(--datepicker-input-min-width);
  @extend .font-base;
}

:host([disabled]) {
  --input-button-color: var(--datepicker-button-disabled-color, var(--datepicker-button-color));
  --input-hover-button-color: var(--datepicker-button-disabled-color, var(--datepicker-button-color));
  --input-label-color: var(--datepicker-button-disabled-color, var(--datepicker-button-color));
  --input-focus-label-color: var(--datepicker-button-disabled-color, var(--datepicker-button-color));
  --input-hover-label-color: var(--datepicker-button-disabled-color, var(--datepicker-button-color));

  #input-container {
    cursor: default;
    background-color: var(--datepicker-input-disabled-background-color);

    .icon-button {
      cursor: default;
      i {
        color: var(--datepicker-button-disabled-color, var(--datepicker-button-color));
      }
    }

    label {
      color: var(--datepicker-label-disabled-color, var(--datepicker-label-color));
    }

    span {
      color: var(--datepicker-text-disabled-color, var(--datepicker-text-color));
    }
  }

  #label-container {
    button {
      cursor: default;

      i {
        color: var(--datepicker-button-disabled-color, var(--datepicker-button-color));
      }
    }

    #datepickerLabel {
      cursor: default;
      text-decoration: none;
      color: var(--datepicker-text-disabled-color, var(--datepicker-text-color));
    }
  }

  #calendar-container {
    display: none;
  }
}

:host(:not([date-picker-hidden]):not([disabled])) {
  z-index: var(--datepicker-host-z-index, 1000);

  #input-container {
    border-color: var(--datepicker-input-border-selected-color);

    label {
      color: var(--datepicker-input-label-selected-color);
    }

    button i {
      color: var(--datepicker-input-button-selected-color);
    }
  }
}

:host([date-picker-hidden]:not([disabled])) {
  #input-container:hover {
    border-color: var(--datepicker-input-border-hover-color);

    label {
      color: var(--datepicker-input-label-hover-color);
    }

    span {
      color: var(--datepicker-input-text-hover-color);
    }

    button i {
      color: var(--datepicker-input-button-hover-color);
    }
  }

  #calendar-container {
    display: none;
  }
}

#label-container {
  position: relative;
  display: flex;
  align-items: center;

  &,
  * {
    background-color: transparent;
  }

  button {
    cursor: pointer;
  }

  #datepickerLabel {
    @include device(smallMobile) {
      font-size: var(--datepicker-label-small-font-size, 16px);
      line-height: var(--datepicker-label-small-line-height, 24px);
    }

    @include device(mobileToTablet) {
      font-size: var(--datepicker-label-medium-font-size, 16px);
      line-height: var(--datepicker-label-medium-line-height, 24px);
    }

    @include device(desktop) {
      font-size: var(--datepicker-label-large-font-size, 16px);
      line-height: var(--datepicker-label-large-line-height, 24px);
    }

    @include device(largeDesktop) {
      font-size: var(--datepicker-label-larger-font-size, 16px);
      line-height: var(--datepicker-label-larger-line-height, 24px);
    }
  }
}

#input-container {
  position: relative;
  width: var(--datepicker-input-width);
  min-width: var(--datepicker-input-min-width);
  height: var(--datepicker-height);
  margin: var(--datepicker-input-margin);
  line-height: normal;
  cursor: pointer;
  border-color: var(--datepicker-input-border-color);
  border-style: var(--datepicker-input-border-style);
  border-width: var(--datepicker-input-border-width);
  border-radius: var(--datepicker-input-border-radius);
  display: var(--datepicker-input-display);
  align-items: var(--datepicker-input-align-items);
  padding: var(--datepicker-input-padding);
  box-sizing: border-box;

  label {
    position: absolute;
    top: 0px;
    left: 0px;
    transform: var(--datepicker-label-transform, translateY(-75%) scale(0.75));
    transform-origin: left top;
    width: 133%;
    pointer-events: none;
    white-space: nowrap;
    color: var(--datepicker-label-color);
  }

  span {
    position: var(--datepicker-text-position);
    right: var(--datepicker-text-right);
    top: var(--datepicker-text-top);
    color: var(--datepicker-text-color);
    display: var(--datepicker-text-display);
    height: var(--datepicker-text-height);
    font-size: var(--datepicker-text-font-size);
    line-height: var(--datepicker-text-line-height);
    background-color: transparent;
  }

  button {
    position: var(--datepicker-button-position);
    right: var(--datepicker-button-right);
    top: var(--datepicker-button-top);
    margin: var(--datepicker-button-margin);

    i {
      color: var(--datepicker-button-color);
    }
  }
}

#editable-input-container {
  .editable-input {
    width: var(--datepicker-input-width);
  }
}

#plain-text-error-message {
  font-family: var(--font-family-light);
  font-weight: var(--font-weight-light);
  font-size: var(--input-standard-font-size);
  line-height: var(--input-line-height, 24px);
  color: var(--input-alert-color);
  margin-top: 5px;
}

#calendar-container {
  z-index: var(--datepicker-calendar-container-z-index, 2000);
  box-shadow: var(--datepicker-calendar-box-shadow);
  box-sizing: border-box;
  background-color: var(--datepicker-calendar-background-color);
  border-color: var(--datepicker-calendar-container-border-color);
  border-style: var(--datepicker-calendar-container-border-style);
  border-width: var(--datepicker-calendar-container-border-width);
  border-radius: var(--datepicker-calendar-container-border-radius);
  margin-top: var(--datepicker-calendar-container-margin);
  right: var(--datepicker-calendar-container-right, unset);

  .calendar-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: var(--datepicker-calendar-header-height);
    padding: var(--datepicker-calendar-header-padding);

    .arrow-button {
      color: var(--datepicker-calendar-arrow-color);

      &.disabled {
        color: var(--datepicker-calendar-arrow-disabled-color);
        cursor: not-allowed;
      }
    }

    .month-title {
      color: var(--primary-dark);

      .month {
        text-transform: capitalize;
        font-family: var(--datepicker-month-font-family);
        font-weight: var(--datepicker-month-font-weight);
      }

      .year {
        font-family: var(--datepicker-year-font-family);
        font-weight: var(--datepicker-year-font-weight);
      }
    }
  }

  .separator {
    display: var(--datepicker-separator-top-display);
    background-color: var(--datepicker-separator-color);
    height: var(--datepicker-separator-height);
    width: var(--datepicker-separator-width);
    margin: var(--datepicker-separator-margin);
  }

  .calendar-body {
    border: var(--datepicker-calendar-border);
    border-radius: var(--datepicker-calendar-border-radius);

    .days-of-week {
      display: flex;

      .day-label {
        color: var(--datepicker-day-of-week-color);
        font-weight: var(--datepicker-day-of-week-font-weight);
        display: flex;
        align-items: center;
        justify-content: center;
        text-transform: uppercase;
      }
    }

    .separator {
      display: var(--datepicker-separator-bottom-display);
      background-color: var(--datepicker-separator-color);
      height: var(--datepicker-separator-height);
      width: var(--datepicker-separator-width);
      margin: var(--datepicker-separator-margin);
    }

    .calendar {
      display: flex;
      flex-wrap: wrap;

      .day-number {
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--datepicker-day-color);
        position: relative;
        cursor: pointer;

        &.highlighted {
          background-color: var(--datepicker-day-background-hover-color);
          color: var(--datepicker-day-text-hover-color);
        }

        .indicator {
          height: var(--datepicker-indicator-height);
          width: var(--datepicker-indicator-width);
          background-color: var(--datepicker-indicator-color);
          border-radius: var(--datepicker-indicator-border-radius);
          display: var(--datepicker-indicator-display);
          position: var(--datepicker-indicator-position);
          bottom: var(--datepicker-indicator-bottom);

          &.single {
            left: var(--datepicker-indicator-left);
          }

          &.first {
            left: var(--datepicker-indicator-first-left);
          }

          &.second {
            left: var(--datepicker-indicator-second-left);
          }

          &.square {
            border-radius: var(--datepicker-indicator-square-border-radius);
          }

          &.diamond {
            border-radius: var(--datepicker-indicator-square-border-radius);
            transform: var(--datepicker-indicator-diamond-rotation);
          }
        }
      }

      .day-number:hover {
        background-color: var(--datepicker-day-background-hover-color);
        color: var(--datepicker-day-text-hover-color);
      }

      .day-number:focus {
        background-color: var(--datepicker-day-background-focus-color);
        color: var(--datepicker-day-text-focus-color);
      }

      .day-number[tabindex='-1'] {
        outline: none;
        visibility: hidden;
      }

      .day-number.disabled {
        color: var(--datepicker-day-text-disabled-color);
        background-color: var(--datepicker-day-background-disabled-color);
      }

      .day-number.active {
        color: var(--datepicker-day-text-active-color);
        background-color: var(--datepicker-day-background-active-color);
      }
    }
  }

  @include device(downToDesktop) {
    position: absolute;
    width: var(--datepicker-width);

    .calendar-header {
      .month-title {
        font-size: var(--datepicker-month-font-size);
      }
    }

    .calendar-body {
      .days-of-week {
        font-size: var(--datepicker-day-of-week-font-size);
        padding: var(--datepicker-day-of-week-padding);

        .day-label {
          width: var(--datepicker-day-of-week-width);
        }
      }

      .calendar {
        padding: var(--datepicker-calendar-padding);

        .day-number {
          width: var(--datepicker-day-width);
          height: var(--datepicker-day-height);
          font-size: var(--datepicker-day-font-size);
        }
      }
    }
  }
}

#calendar-button-label-left {
  padding-right: 12px;
}

#calendar-button-label-right {
  padding-left: 12px;
}

#calendar-button-right {
  padding-left: 2px;
}

.icon-button {
  border: none;
  padding: 0px;
  margin: 0px;
  cursor: pointer;
  background-color: transparent;
}
.icon-button:focus-visible {
  outline: var(--outline-width) var(--outline-style) var(--outline-color);
  border-radius: 3px;
}

// element.mobile.scss

@include device(smallMobile) {
  :host {
    width: 100%;
    --input-width: 100%;
    --input-min-width: 100%;
  }
  #calendar-container {
    width: var(--datepicker-calendar-container-small-mobile-width, 100%);
    position: var(--datepicker-calendar-container-small-mobile-position, unset);

    .calendar-header {
      .month-title {
        font-size: 16px;
      }
    }

    .calendar-body {
      .days-of-week {
        font-size: 14px;
        padding: 10px 18px;

        .day-label {
          width: calc(100% / 7);
          height: auto;
        }
      }
      .calendar {
        padding: 8px 17px;

        .day-number {
          width: calc(100% / 7);
          height: 44px;
          font-size: 16px;
        }
      }
    }
  }

  #input-container {
    width: 100%;
  }
}

@include device(mobileToTablet) {
  :host {
    --input-width: var(--datepicker-input-width);
    --input-min-width: var(--datepicker-input-min-width);
  }

  #calendar-container {
    width: var(--datepicker-calendar-container-mobile-to-tablet-width, 345px);
    position: var(--datepicker-calendar-container-mobile-to-tablet-position, unset);

    .calendar-header {
      .month-title {
        font-size: 16px;
        font-size: 16px;
      }
    }

    .calendar-body {
      .days-of-week {
        font-size: 14px;
        padding: 10px 18px;

        .day-label {
          height: 25px;
          width: 44px;
        }
      }
      .calendar {
        padding: 8px 17px;

        .day-number {
          width: 44px;
          height: 44px;
          font-size: 16px;
        }
      }
    }
  }
}

:host([variant='always-open']) {
  #calendar-container {
    position: unset;
    margin-top: 0;
  }
}

:host([variant='always-open'][disabled]) {


  #calendar-container {
    display: block;
    cursor: default;

    box-shadow: var(--datepicker-calendar-box-shadow);
    background-color: var(--datepicker-input-disabled-background-color);
    border-color: var(--datepicker-calendar-container-border-color);

    * {
        color: var(--datepicker-day-text-disabled-color) !important;
        background-color: var(--datepicker-input-disabled-background-color) !important;
        cursor: default !important;
    }

    .separator {
      background-color: var(--datepicker-day-text-disabled-color) !important;
    }

  }
}
